/* eslint-disable no-restricted-syntax */
import { mapActions, mapGetters, mapState } from 'vuex';
import loaderMixin from '@/mixins/loader';
import cmsContentMixin from '@/mixins/cmsContent';
import { flatten, get } from 'lodash'
import { stripTags } from '@/utils/helpers';
import Vue from 'vue'

export default {
  mixins: [
    cmsContentMixin,
    loaderMixin,
  ],
  data() {
    return {
      stripTags,
      fullHtml: '',
    };
  },
  computed: {
    ...mapGetters('app', ['isLayoutMobile', 'isLayoutDesktop']),
    ...mapState('browse', ['storiesNav', 'storiesUseLegacyPreload', 'storyMap']),
    ...mapState('popup', ['currentPopup', 'currentSmallPopup']),
  },
  methods: {
    ...mapActions('browse', ['getStoriesNav', 'getStory', 'getStoriesList']),
    ...mapActions('popup', ['setCurrentPopup']),
    setupContent () {
      const totalCmsContent = [];
      console.log(this.storyMap);
      for (const [index, data] of Object.entries(this.storyMap)) {
        console.log(data);
        totalCmsContent.push(data.mobileContent.cmsContent);
        this.fullHtml = `${this.fullHtml}${data.mobileContent.css || ''}${data.mobileContent.html || ''}`;

      }
      const accordionContentObjects = flatten(totalCmsContent.map((i) => i.accordionContentObjects));
      const podcastItemContentObjects = flatten(totalCmsContent.map((i) => i.podcastItemContentObjects));
      const contractListMarkets = flatten(totalCmsContent.map((i) => i.contractListMarkets));
      const marketTileMarkets = flatten(totalCmsContent.map((i) => i.marketTileMarkets));
      const chartWidgetObjects = flatten(totalCmsContent.map((i) => i.chartWidgetObjects));
      const docsWidgetObjects = flatten(totalCmsContent.map((i) => i.docsWidgetObjects));
      const videoWidgetObjects = flatten(totalCmsContent.map((i) => i.videoWidgetObjects));
      setTimeout(() => {
        this.installDynamicControls({
          data: {
            cmsContentObject: {
              accordionContentObjects,
              podcastItemContentObjects,
              contractListMarkets,
              marketTileMarkets,
              chartWidgetObjects,
              docsWidgetObjects,
              videoWidgetObjects
            }
          },
        });
      }, 0)
    },
    start() {
      this.loaderAdd(document.body);
      this.getStoriesNav()
        .then((data) => {
          if (data.length === 0) {
            this.loaderRemove(document.body);
            Promise.resolve(1);
          }

          if (this.storiesUseLegacyPreload) {
            const promises = [];
            for (const item of data) {
              promises.push(this.getStory({ index: item.index }));
            }

             Promise.all(promises).then(() => {
               this.loaderRemove(document.body);
                this.setupContent();
             })
          } else {
            const indexes = data.map((i) => i.index);
            this.getStoriesList({ indexes, cache: true })
              .then((data) => {
                this.loaderRemove(document.body);
                this.setupContent();
              })
              .catch(() => this.loaderRemove(document.body));
          }

          })
        .catch(() => this.loaderRemove(document.body));
    },
  },
  mounted() {
    this.start();
  },
};



// WEBPACK FOOTER //
// ./src/components/cms/preview-carousel-mobile/preview-carousel-mobile.js